import { getRuntimeConfig } from '@/lib/runtimeConfig';
/**
 * SPA redirect URI — same pattern as Smart Repay.
 * Register EVERY host you use in Entra → Authentication → SPA:
 *   http://localhost:5173/msal-redirect.html
 *   https://YOUR-HOSTINGER-DOMAIN/msal-redirect.html
 */
export function getMsalRedirectUri() {
    const fromEnv = (import.meta.env.VITE_AZURE_REDIRECT_URI || '').trim();
    if (fromEnv)
        return fromEnv.replace(/\/$/, '');
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/msal-redirect.html`;
    }
    return 'http://localhost:5173/msal-redirect.html';
}
export function getPostLogoutRedirectUri() {
    // HashRouter login route
    if (typeof window !== 'undefined' && window.location?.origin) {
        return `${window.location.origin}/#/login`;
    }
    return 'http://localhost:5173/#/login';
}
function getClientId() {
    return getRuntimeConfig().azureClientId || import.meta.env.VITE_AZURE_CLIENT_ID || '';
}
function getTenantId() {
    return getRuntimeConfig().azureTenantId || import.meta.env.VITE_AZURE_TENANT_ID || 'common';
}
/**
 * Login scopes = basic profile only. Mail.Read / Mail.ReadWrite are
 * admin-consent-sensitive in this tenant, so requesting them at login shows
 * "Need admin approval" and blocks sign-in. Mail scopes are requested later
 * (inbox load) via redirect, so login stays clean like before.
 */
export const loginScopes = ['openid', 'profile', 'email', 'User.Read'];
/** Preferred: read + PATCH Outlook categories. */
export const graphScopes = ['User.Read', 'Mail.ReadWrite'];
/** Fallback if Write is not consented — still load inbox content. */
export const graphReadScopes = ['User.Read', 'Mail.Read'];
export const ALLOWED_SIGNIN_DOMAIN = 'genesisfundservices.com';
export const loginRequest = {
    scopes: loginScopes,
    domainHint: ALLOWED_SIGNIN_DOMAIN,
    prompt: 'select_account',
};
export const graphTokenRequest = {
    scopes: graphScopes,
};
/** Call after loadRuntimeConfig() so Hostinger config.json is applied. */
export function createMsalConfig() {
    const clientId = getClientId();
    const tenantId = getTenantId();
    return {
        auth: {
            clientId,
            authority: `https://login.microsoftonline.com/${tenantId}`,
            redirectUri: getMsalRedirectUri(),
            postLogoutRedirectUri: getPostLogoutRedirectUri(),
        },
        cache: {
            cacheLocation: 'sessionStorage',
        },
    };
}
export function isAzureConfigured() {
    const clientId = getClientId();
    const tenantId = getTenantId();
    return clientId.length > 0 && tenantId.length > 0 && tenantId !== 'common';
}
